import { BRAND, aboutCredentials, images, payrollCredential, platformLogos } from '../data';

const credentialItems = [
  ...aboutCredentials.map((item) => ({ ...item, size: 'lg', kind: 'intuit' })),
  { ...payrollCredential, size: 'lg', kind: 'intuit', tone: 'mist' },
  ...platformLogos.map((item) => ({ ...item, size: 'sm', kind: 'platform', tone: 'mist' })),
];

export default function About() {
  return (
    <section className="section about" id="about">
      <div className="container">
        <div className="about-layout" data-reveal>
          <div className="about-copy">
            <h2 className="display-2">
              Experience behind <em>the books.</em>
            </h2>
            <p className="lede">
              Good bookkeeping starts with understanding the business and getting the details right.
            </p>
            <p>
              Before founding Rime, Dinar Davis worked across finance and operations roles in
              organizations ranging from 20th Century Studios, The Ritz-Carlton, and nonprofits in
              the legal and education sectors. Each environment meant learning a different business,
              including its customers, vendors, financial processes, and the intricacies that made
              it all work.
            </p>
            <p>
              His experience across these different businesses, managing bookkeeping, payroll,
              accounts payable and receivable, budgeting, financial analysis, auditing, federal and
              state taxes, and day-to-day operations, forms the foundation of Rime’s tailored
              approach to bookkeeping and payroll: accurate records, consistent processes, and
              financials you can actually use.
            </p>
          </div>

          <figure className="portrait-frame">
            <img
              src={images.founder}
              alt={`Dinar Davis, founder of ${BRAND}`}
              width="1232"
              height="1277"
              loading="lazy"
              decoding="async"
            />
          </figure>
        </div>

        <div className="credential-suite" data-reveal>
          <p className="credential-suite-label">Professional credentials &amp; platforms</p>
          <div className="credential-badges">
            {credentialItems.map((item) => (
              <div
                className={`credential-badge is-${item.kind}${item.tone === 'mist' ? ' is-mist' : ''}`}
                key={item.name}
                title={item.name}
              >
                <img
                  className={`credential-logo${item.size === 'lg' ? ' credential-logo-lg' : ' platform-logo'}`}
                  src={item.src}
                  alt={item.name}
                  loading="lazy"
                  decoding="async"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
